import React from 'react';
import { useFormContext } from 'react-hook-form';
import { StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { Localize, useTranslate } from '@agilepoint/wat-react';
import { useLocaleValues } from 'modules/create-new-app/components/app-wizard/forms';
import { MenuOptionsWrapper, StyledGrid, StyledText, StyledToggledInput, LocaleDropdownField } from '../styled-components';
import { useMenuOptions } from '../hooks';
import { ElasticTextBoxField, GridLayout, StyledStackPanel } from 'common';

interface IMenuOptionsFormProps {
    containerHeight?: string;
    headerLabel?: string;
    subHeading?: string;
}

export const MenuOptionsForm = React.memo((props: IMenuOptionsFormProps) => {
    const { containerHeight, headerLabel, subHeading } = props;
    const translate = useTranslate();
    const locales = useLocaleValues();
    const { watch } = useFormContext();
    const menuOptions = useMenuOptions();

    return (
        <StyledStackPanel margin='30px 0px 0px 0px' orientation='vertical' gap="30" width="100%" height={containerHeight ?? 'calc(100% - 111px)'} alignment="center">
            <StackPanel gap="10" orientation='vertical' alignment="center" width='100%'>
                <Typography.H2 title={headerLabel ? headerLabel : translate('modules.createNewApp.steps.menuOptions.customFeaturesHeader')}>
                    {headerLabel ? headerLabel : <Localize translate='modules.createNewApp.steps.menuOptions.customFeaturesHeader' />}
                </Typography.H2>
                {subHeading ? <Typography.Medium title={subHeading}> {subHeading} </Typography.Medium> : <></>}
            </StackPanel>
            <StackPanel gap="40" width="600px">
                <Typography.H4 title={translate('modules.createNewApp.steps.menuOptions.translateNamesIn')}><Localize translate='modules.createNewApp.steps.menuOptions.translateNamesIn' /></Typography.H4>
                <LocaleDropdownField
                    name="locales"
                    gap="4"
                    items={locales}
                    title={watch('locales')} />
            </StackPanel>
            <MenuOptionsWrapper>
                <StyledGrid $gridGap="25px" $overflow="auto" >
                    {menuOptions.map((option) => (
                        <GridLayout key={`${watch('locales')}.${option.Name}`} $alignItems="center" $gridTemplateColumns="33% 56% 11%">
                            <StyledText title={option.Name}>{translate(`modules.createNewApp.steps.menuOptions.menuOptionsLabel.${option.Name}`)}</StyledText>
                            <ElasticTextBoxField $width="326px" name={`[menuOptions][${watch('locales')}].[${option.Name}].fieldValue`} defaultValue={option.Value} title={option.Value} />
                            <StyledToggledInput
                                name={`[menuOptions][${watch('locales')}].[${option.Name}].isEnabled`}
                                hidden={(option.Name === 'MyApps' || option.Name === 'MyTasks' || option.Name === 'About'|| option.Name === 'Home'|| option.Name === 'Outbox'|| option.Name === 'TeamTasks')}
                                defaultChecked={option.isEnabled} />
                        </GridLayout>
                    ))}
                </StyledGrid>
            </MenuOptionsWrapper>
        </StyledStackPanel>
    );
});
